import { useEffect, useState } from "react"
import { getUnitsOfTime } from "./utils"

export const useCountdown = (targetDateString: string): number[] => {
  const targetDate = new Date(targetDateString)
  const now = new Date()

  const utcOffsetMinutes = targetDate.getTimezoneOffset()
  const isNegativeOffset = utcOffsetMinutes < 0

  let targetTimeInLocal
  if (isNegativeOffset) {
    targetTimeInLocal = new Date(
      targetDate.getTime() + utcOffsetMinutes * 60000
    )
  } else {
    targetTimeInLocal = new Date(
      targetDate.getTime() - utcOffsetMinutes * 60000
    )
  }

  const timeDifference = targetTimeInLocal.getTime() - now.getTime()

  const [countDown, setCountDown] = useState(timeDifference)

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(targetTimeInLocal.getTime() - Date.now())
    }, 1000)

    return () => clearInterval(interval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetDateString])

  return getUnitsOfTime(countDown)
}
